import { Menu } from "../components/menu";

export const Page = (props) => {
  const {children} = props;

  return <Menu>
    {children}
  </Menu>
}